import type { ListRegionChannelSettingsQuery } from '~/services/PromoService';

export const regionChannelSettingQueryKeys = {
  all: ['region-channel-settings'] as const,
  lists: () => [...regionChannelSettingQueryKeys.all, 'list'] as const,
  list: (filters: ListRegionChannelSettingsQuery) => [...regionChannelSettingQueryKeys.lists(), filters] as const,
  detail: (id: string) => [...regionChannelSettingQueryKeys.all, 'detail', id] as const,
};
